/* ALTON — product page: variant selection, price/availability updates,
   URL sync, media swap, quantity, lightbox gallery. */
(function () {
  'use strict';

  function initProductForm(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';

    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var variants = data.variants;
    var optionCount = data.options.length;

    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var addButton = root.querySelector('[data-add-button]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var inventoryEl = root.querySelector('[data-inventory]');
    var selected = (root.dataset.selectedOptions || '').split('||');

    function currentVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function valueAvailable(index, value) {
      return variants.some(function (v) {
        if (v.options[index] !== value) return false;
        for (var i = 0; i < optionCount; i++) {
          if (i !== index && selected[i] && v.options[i] !== selected[i]) return false;
        }
        return v.available;
      });
    }

    function updateLabels() {
      root.querySelectorAll('[data-option-label]').forEach(function (el) {
        var i = parseInt(el.dataset.optionLabel, 10);
        el.textContent = selected[i] || '';
      });
    }

    function updateUI() {
      var variant = currentVariant();

      root.querySelectorAll('[data-option-value]').forEach(function (btn) {
        var i = parseInt(btn.dataset.optionIndex, 10);
        var val = btn.dataset.optionValue;
        btn.setAttribute('aria-pressed', selected[i] === val ? 'true' : 'false');
        btn.classList.toggle('unavailable', !valueAvailable(i, val));
      });
      updateLabels();

      if (!variant) {
        if (addButton) {
          addButton.setAttribute('disabled', '');
          addButton.textContent = addButton.dataset.unavailableText;
        }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price_formatted;
      if (compareEl) {
        if (variant.compare_at_price_formatted && variant.compare_at_price > variant.price) {
          compareEl.textContent = variant.compare_at_price_formatted;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (addButton) {
        if (variant.available) {
          addButton.removeAttribute('disabled');
          addButton.textContent = addButton.dataset.addText + (variant.price_formatted ? ' — ' + variant.price_formatted : '');
        } else {
          addButton.setAttribute('disabled', '');
          addButton.textContent = addButton.dataset.soldOutText;
        }
      }
      if (inventoryEl) {
        var qty = variant.inventory_quantity;
        if (variant.inventory_managed && variant.available && qty > 0 && qty <= 5) {
          inventoryEl.textContent = inventoryEl.dataset.lowText.replace('[qty]', qty);
          inventoryEl.hidden = false;
        } else {
          inventoryEl.hidden = true;
        }
      }

      if (variant.featured_media_id) {
        var mediaEl = root.querySelector('[data-media-id="' + variant.featured_media_id + '"]');
        if (mediaEl && mediaEl.scrollIntoView && window.innerWidth >= 1080) {
          mediaEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }

      if (window.history && window.history.replaceState && root.dataset.updateUrl === 'true') {
        window.history.replaceState({}, '', data.url + '?variant=' + variant.id);
      }
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-option-value]');
      if (btn) {
        e.preventDefault();
        selected[parseInt(btn.dataset.optionIndex, 10)] = btn.dataset.optionValue;
        updateUI();
        return;
      }
      var qtyBtn = e.target.closest('[data-qty-step]');
      if (qtyBtn) {
        e.preventDefault();
        var input = root.querySelector('input[name="quantity"]');
        if (input) input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(qtyBtn.dataset.qtyStep, 10));
      }
    });

    updateUI();
  }

  /* ---------- Lightbox ---------- */
  function initLightbox(root) {
    var lightbox = document.getElementById('ProductLightbox');
    if (!lightbox || lightbox.dataset.initialized) return;
    lightbox.dataset.initialized = 'true';

    var img = lightbox.querySelector('img');
    var sources = [];
    var index = 0;

    function collect() {
      sources = Array.prototype.map.call(document.querySelectorAll('[data-lightbox-open]'), function (el) {
        return el.dataset.lightboxSrc;
      }).filter(Boolean);
    }
    function show() {
      if (img && sources[index]) { img.src = sources[index]; }
    }
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-lightbox-open]');
      if (opener) {
        e.preventDefault();
        collect();
        index = sources.indexOf(opener.dataset.lightboxSrc);
        if (index < 0) index = 0;
        show();
        if (window.altonOverlay) window.altonOverlay.open(lightbox, { lockScroll: true, trigger: opener });
        return;
      }
      if (!lightbox.classList.contains('open')) return;
      if (e.target.closest('[data-lb-prev]')) { e.preventDefault(); index = (index - 1 + sources.length) % sources.length; show(); }
      else if (e.target.closest('[data-lb-next]')) { e.preventDefault(); index = (index + 1) % sources.length; show(); }
      else if (e.target.closest('[data-lb-close]') || e.target === lightbox) { e.preventDefault(); window.altonOverlay.close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('open')) return;
      if (e.key === 'ArrowLeft') { index = (index - 1 + sources.length) % sources.length; show(); }
      if (e.key === 'ArrowRight') { index = (index + 1) % sources.length; show(); }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-product-root]').forEach(initProductForm);
    initLightbox();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
